import aiLogsAPI from '../../../api/nexceo/aiLogs';

const state = {
  leadLogs: {},
  analytics: null,
  isLoading: false,
};

const getters = {
  getLogsForLead: s => leadId => s.leadLogs[leadId] || [],
  getAnalytics: s => s.analytics,
  isLoading: s => s.isLoading,
};

const mutations = {
  SET_LEAD_LOGS(s, { leadId, logs }) {
    s.leadLogs = { ...s.leadLogs, [leadId]: logs };
  },
  SET_ANALYTICS(s, data) {
    s.analytics = data;
  },
  SET_LOADING(s, val) {
    s.isLoading = val;
  },
};

const actions = {
  fetchLeadLogs: async ({ commit }, { accountId, leadId, filters = {} }) => {
    commit('SET_LOADING', true);
    try {
      const { data } = await aiLogsAPI.getLeadLogs(accountId, leadId, filters);
      commit('SET_LEAD_LOGS', { leadId, logs: data.logs || [] });
      return data;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  fetchAnalytics: async ({ commit }, { accountId, filters = {} }) => {
    commit('SET_LOADING', true);
    try {
      const { data } = await aiLogsAPI.getAnalytics(accountId, filters);
      commit('SET_ANALYTICS', data.meta || null);
      return data.meta;
    } finally {
      commit('SET_LOADING', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
